import type { ReactNode } from 'react'

/**
 * Nhãn + gợi ý + lỗi bao quanh một input. Nhãn tiếng Việt, `name` tiếng Anh (CLAUDE.md §3).
 *
 * ⚠️ **Dùng `as="div"` khi con KHÔNG phải một input đơn.** `<label>` không có `for` sẽ chuyển
 * tiếp mọi click ở vùng không tương tác sang phần tử labelable đầu tiên bên trong. Với
 * `ImageField` (ô thumbnail + nút "Chọn ảnh") thì bấm vào ô ảnh — hay bấm vào chính chữ
 * "Ảnh đại diện" — cũng **mở hộp chọn ảnh**. Không ai thiết kế thế, và người dùng thấy nó như
 * hộp thoại tự bật lại sau khi vừa chọn xong. Đo được: một cú bấm vào ô thumbnail = hộp thoại
 * mở + 1 request `/api/media`. Xem `docs/DECISIONS.md` #30.
 */
export function Field({
  label, hint, error, required, children, className = '', as: Tag = 'label',
}: {
  label: string
  hint?: string
  error?: string
  required?: boolean
  children: ReactNode
  className?: string
  as?: 'label' | 'div'
}) {
  return (
    <Tag className={`block ${className}`}>
      <span className="mb-1.5 block text-sm font-medium text-ink">
        {label}
        {required && <span className="ml-0.5 text-danger">*</span>}
      </span>
      {children}
      {error ? (
        <span className="mt-1 block text-xs text-danger">{error}</span>
      ) : hint ? (
        <span className="mt-1 block text-xs text-ink-muted">{hint}</span>
      ) : null}
    </Tag>
  )
}
